import { localStorageInstance } from '../instances/localStorageInstance';

const DEVICE_ID_STORAGE_KEY = 'device_id';

export function set(deviceId: string): void {
  localStorageInstance.setItem(DEVICE_ID_STORAGE_KEY, deviceId);
}

export function get(): string {
  return localStorageInstance.getItem(DEVICE_ID_STORAGE_KEY) || '';
}

export function remove(): void {
  return localStorageInstance.removeItem(DEVICE_ID_STORAGE_KEY);
}
